import React from "react";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { googleLogout } from "@react-oauth/google";
import EventBusyRounded from "@mui/icons-material/EventBusyRounded";
import StatusScreen from "./StatusScreen";

const ExpiredSubscription: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [, , removeCookie] = useCookies(["uuid"]);

    const handleLogout = () => {
        removeCookie("uuid");
        localStorage.removeItem("uuid");
        googleLogout();
        window.location.reload();
    };

    return (
        <StatusScreen
            icon={EventBusyRounded}
            iconColor={theme.palette.warning.main}
            title="Subscription Expired"
            subtitle="Your subscription is no longer active. Renew your plan to continue using all features."
            buttonLabel="Renew Subscription"
            onButtonClick={() => navigate("/menu/subscriptions")}
            secondaryButtonLabel="Log Out"
            onSecondaryClick={handleLogout}
        />
    );
};

export default ExpiredSubscription;
